module.exports = __webpack_public_path__ + "img/10890_S.e51ba34b.png";